import { render, staticRenderFns } from "./SelectedProductItem.vue?vue&type=template&id=6443cf35&scoped=true&"
import script from "./SelectedProductItem.vue?vue&type=script&lang=js&"
export * from "./SelectedProductItem.vue?vue&type=script&lang=js&"
import style0 from "./SelectedProductItem.vue?vue&type=style&index=0&id=6443cf35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6443cf35",
  null
  
)

export default component.exports